<template>
  <div class="wrap">
    <div style="text-align: left;padding: 15px 29px;display: flex;align-items: center;">
      <van-icon name="arrow-left" size="20px" color="#000" @click="goBack" />
      <div style="font-size: 16px;color: #14142B;font-weight: 600;margin-left: 33%;">订单结算</div>
    </div>
    <div style="text-align: left;padding: 15px 29px 8px;display: flex;align-items: center;">
      <div style="font-size: 15px;color: #14142B;font-weight: 600;">收货信息</div>
    </div>
    <div v-if="address_list.length <= 0">
      <div style="padding-left: 7%;">
        <div style="width: 92%; height: 47px; background: #FFFFFF; border: 1px solid #9E9E9E; display: flex; align-items: center; justify-content: center; color: #14142B; font-size: 14px;" @click="showAddressForm = true">
          + 选择收货地址
        </div>
      </div>
    </div>
    
    <van-popup v-model="showAddressForm" position="top" :style="{ height: '100%' }">
      <div class="address_info">
        <div class="address_form_header">
          <h3>选择并设置收货地址</h3>
          <van-icon name="cross" @click="showAddressForm = false" />
        </div>
        <div class="adddz" v-if="address_list.length >= 0">
          <form @submit="saveAddress">
            <div class="address_input_item">
              <label>
                收货人
                <span>*</span>
              </label>
              <input
                type="text"
                maxlength="50"
                placeholder="请输入"
                v-model="full_name"
                required
              />
            </div>

            <div class="address_input_item">
              <label>
                手机号
                <span>*</span>
              </label>
              <input
                type="text"
                placeholder="请输入"
                v-model="tel"
              />
            </div>

            <div class="address_input_item">
              <label>
                所在地区
                <span>*</span>
              </label>
              <input
                type="text"
                readonly
                placeholder="请输入"
                @click="showCountryPicker = true"
                v-model="countryName"
              />
              <van-popup v-model="showCountryPicker" position="bottom">
                <van-picker
                  show-toolbar
                  value-key="name"
                  :columns="countryPicker"
                  @cancel="showCountryPicker = false"
                  @confirm="changeCity($event, 'country')"
                />
              </van-popup>
            </div>

            <div class="address_input_item">
              <label>
                城市
                <span>*</span>
              </label>
              <input
                type="text"
                readonly
                placeholder="请输入"
                @click="showStatePicker = true"
                v-model="stateName"
              />
              <van-popup v-model="showStatePicker" position="bottom">
                <van-picker
                  show-toolbar
                  value-key="name"
                  :columns="statePicker"
                  @cancel="showStatePicker = false"
                  @confirm="changeCity($event, 'state')"
                />
              </van-popup>
            </div>

            <div class="address_input_item">
              <label>
                区县
                <span>*</span>
              </label>
              <input
                type="text"
                readonly
                placeholder="请输入"
                @click="showCityPicker = true"
                v-model="cityName"
              />
              <van-popup v-model="showCityPicker" position="bottom">
                <van-picker
                  show-toolbar
                  value-key="name"
                  :columns="cityPicker"
                  @cancel="showCityPicker = false"
                  @confirm="changeCity($event, 'city')"
                />
              </van-popup>
            </div>

            <div class="address_input_item">
              <label>
                详细地址
                <span>*</span>
              </label>
              <input 
                type="text" 
                placeholder="请输入"
                v-model="address_line" 
                required 
              />
            </div>

            <div class="set_default_address">
              <van-checkbox v-model="isDefaultAddress" checked-color="#14142B">设为默认</van-checkbox>
            </div>
            
            <div class="save_btn_container">
              <button type="submit" class="save_address_btn">保存</button>
            </div>
          </form>
        </div>
      </div>
    </van-popup>
    <div class="container container_top" style="padding: 0 29px;box-sizing: border-box;">
      <router-link
        class="ress_tz"
        :to="{ path: 'selectaddress', query: { id: base.address.id } }"
        v-if="address_list.length > 0"
      >
        <van-row
          class="pay_reasss"
          type="flex"
          align="center"
          justify="space-between"
          style="border: 1px solid #9E9E9E;"
        >
          <van-col>
            <van-icon name="location-o" />
          </van-col>
          <van-col style="flex:1">
            <div class="name">
              <span>{{ base.address.name }}</span>
              {{ base.address.tel }}
            </div>
            <div>
              {{ base.address.address }} {{ base.address.address_line2 }}
              {{ base.address.city_name }}
              {{ base.address.province_name }}
              <!-- {{ base.address.email }} -->
            </div>
          </van-col>
          <van-col>
            <van-icon name="arrow" />
          </van-col>
        </van-row>
      </router-link>

      <div class="carts pay" style="margin-top: 15px;">
        <div v-for="(item, index) in goods_list" :key="index" class="product-container">
          <div class="product-image-container">
            <van-image width="130" height="165" lazy-load :src="item.images" fit="cover" class="product-image" />
          </div>
          <div class="product-details">
            <div class="product-title">{{ item.title }}</div>
            <div class="product-specs">
              <span v-for="(value, idx) in item.spec" :key="idx" class="spec-item">
                {{ value.value }}
              </span>
              <span class="spec-item">数量 {{ item.stock }}</span>
            </div>
            <div class="product-price"><span style="font-size: 14px;font-weight: 500;">￥</span> {{ Number(item.total_price).toFixed(2) }}</div>
          </div>
        </div>
        
        <div class="order-summary">
          <div class="summary-item">
            <span class="summary-label">备注</span>
            <span class="summary-value">无备注 ></span>
          </div>
          <div class="summary-item">
            <span class="summary-label">运费</span>
            <span class="summary-value">￥ {{ Number(shipping_cost).toFixed(2) }}</span>
          </div>
          <div class="summary-item">
            <span class="summary-label discount">促销</span>
            <span class="summary-value discount">-￥ {{ Number(coupon_money).toFixed(2) }}</span>
          </div>
        </div>
      </div>
  
      <div class="pay_mode">
        <van-radio-group v-model="radio1">
          <div class="payment-option">
            <van-radio name="2" checked-color="#000000" @click="chooespay">
              <van-row type="flex" align="center">
                <van-image
                  height="20"
                  width="112"
                  flt="contain"
                  lazy-load
                  src="https://www.jqxtech.com/images/alipay.png"
                />
              </van-row>
            </van-radio>
            <div class="payment-selected" :class="{ active: radio1 === '2' }">
              <van-icon v-if="radio1 === '2'" name="success" color="#fff" size="14" />
            </div>
          </div>
          
          <div class="payment-option">
            <van-radio name="1" checked-color="#000000" @click="chooespay">
              <van-row type="flex" align="center">
                <van-image
                  height="20"
                  width="97"
                  flt="contain"
                  lazy-load
                  src="https://www.jqxtech.com/images/wechat.png"
                />
              </van-row>
            </van-radio>
            <div class="payment-selected" :class="{ active: radio1 === '1' }">
              <van-icon v-if="radio1 === '1'" name="success" color="#fff" size="14" />
            </div>
          </div>
        </van-radio-group>
      </div>

      <!-- <h3 class="pay_titile">订单汇总</h3> -->
      <div class="address_order_total">
        <van-row
          class="total_list discount"
          type="flex"
          align="center"
          justify="space-between"
        >
          <van-col>共减:</van-col>
          <van-col style="color: #FF6E27 !important;"><span style="font-size: 12px;">￥</span> {{ Number(coupon_money).toFixed(2) }}</van-col>
        </van-row>
        <van-row
          class="total_list"
          type="flex"
          align="center"
          justify="space-between"
        >
          <van-col>总计:</van-col>
          <van-col style="color: #14142B;"><span style="font-size: 12px;">￥</span> {{ Number(grand_total).toFixed(2) }}</van-col>
        </van-row>
      </div>
      <van-row type="flex" align="center" justify="center">
        <div class="payment_but">
          <van-button type="primary" block @click="pay">提交订单</van-button>
        </div>
      </van-row>
    </div>
  </div>
</template>
<style scoped>
.container_top {
  /* margin-top: 45px; */
}

.address_form_header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px;
  border-bottom: 1px solid #E9E9E9;
  box-sizing: border-box;
}

.address_form_header h3 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #14142B;
}

.address_info {
  background-color: #fff;
  height: 100%;
}

.adddz {
  padding: 15px;
}

.address_input_item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 15px;
}

.address_input_item label {
  display: block;
  font-size: 14px;
  font-weight: 600;
  color: #14142B;
  margin-bottom: 8px;
}

.address_input_item label span {
  color: #EB5757;
}

.address_input_item input {
  width: 77%;
  height: 47px;
  border: 1px solid #9E9E9E;
  box-sizing: border-box;
  padding: 0 15px;
  font-size: 14px;
  color: #14142B;
}

.set_default_address {
  margin: 20px 0;
}

.save_btn_container {
  margin-top: 30px;
}

.save_address_btn {
  width: 100%;
  height: 47px;
  background-color: #14142B;
  color: white;
  border: none;
  font-size: 14px;
  font-weight: 600;
}
:deep(.van-popup--top){
  top: 9%;
}
:deep(.van-overlay){
  background-color: rgb(0 0 0 / 0%);
}

.pay_mode {
  margin: 20px 0;
  border-top: 1px solid #CCCCCC;
  border-bottom: 1px solid #CCCCCC;
  overflow: hidden;
  padding: 12px 0;
}

.payment-option {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
}


.payment-name {
  margin-left: 10px;
  font-size: 14px;
  color: #333333;
}

.payment-selected {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 1px solid #DDDDDD;
  display: flex;
  align-items: center;
  justify-content: center;
}

.payment-selected.active {
  background-color: #2E333A;
  border-color: #2E333A;
}

:deep(.van-radio) {
  display: flex;
  align-items: center;
  width: 92%;
}

:deep(.van-radio__icon) {
  display: none;
}

:deep(.van-radio__label) {
  margin-left: 0;
  padding: 0;
}

.pay_titile {
  font-size: 16px;
  font-weight: 600;
  color: #14142B;
  margin: 15px 0;
  text-align: left;
}
.payment_but{
  width: 100%;
  margin: 17px 0 50px 0;
}
:deep(.van-button){
  height: 48px;
}
/* 商品卡片样式 */
:deep(.product-card) {
  background-color: #ffffff;
  padding: 10px 0;
  margin-bottom: 10px;
  border-radius: 0;
  box-shadow: none;
}

:deep(.product-card .van-card__header) {
  display: flex;
  align-items: center;
}

:deep(.product-card .van-card__thumb) {
  width: 70px;
  height: 70px;
  margin-right: 12px;
}

:deep(.product-card .van-card__content) {
  padding-left: 0;
}

.product-title {
  font-size: 14px;
  color: #14142B;
  font-weight: 600;
  text-align: left;
}

.spec-item {
  font-size: 12px;
  color: #9E9E9E;
  margin-right: 8px;
}

.product-info {
  margin-top: 8px;
}

.price-info, .quantity-info {
  display: flex;
  align-items: center;
}

.price-label, .quantity-label {
  font-size: 12px;
  color: #9E9E9E;
  margin-right: 4px;
}

.price-value {
  font-size: 14px;
  color: #F7931A;
  font-weight: 600;
}

.quantity-value {
  font-size: 14px;
  color: #14142B;
  font-weight: 600;
}

/* 商品展示样式 */
.product-container {
  display: flex;
  padding: 15px 0;
  background-color: #ffffff;
}

.product-image-container {
  flex: 0 0 140px;
  margin-right: 1px;
}

.product-image {
  border-radius: 0;
}

.product-details {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  text-align: left;
  padding-right: 10px;
}

.product-title {
  font-size: 15px;
  color: #14142B;
  font-weight: 600;
  line-height: 1.4;
  margin-bottom: 20px;
}

.product-specs {
  margin-bottom: 12px;
  margin-top: -47px;
}

.spec-item {
  font-size: 14px;
  color: #14142B;
  margin-right: 15px;
}

.product-price {
  font-size: 17px;
  color: #14142B;
  text-align: right;
  font-weight: 600;
}

.order-summary {
  border-top: 1px solid #f3f3f3;
  padding-top: 8px;
}

.summary-item {
  display: flex;
  justify-content: space-between;
  padding: 7px 0;
  font-weight: 600;
}

.summary-label {
  font-size: 14px;
  color: #14142B;
}

.summary-value {
  font-size: 14px;
  color: #14142B;
}

.discount {
  color: #FF6E27;
}

:deep(.product-card) {
  display: none;
}
.address_order_total{
  font-size: 16px;
}
.address_order_total .total_list{
  margin-bottom: 14px;
}
</style>
<script>
export default {
  components: {},
  created() {
    this.buy_type = this.$route.query.buy_type;
    this.ids = this.$route.query.ids;
    this.getData();
    this.user_info = this.getUserInfo();
    this.email = this.user_info.email;
    localStorage.setItem(
      "pay_path",
      "/pay?ids=" + this.ids + "&buy_type=" + this.buy_type
    );
  },
  data() {
    return {
      showAddressForm: false,
      coupons: "",
      columns: [],
      showPicker: false,
      radio: "1",
      radio1: "2",
      ids: "",
      buy_type: "",
      goods_list: [],
      address_list: [],
      base: [],
      shipping_cost: 0.0,
      grand_total: 0.0,
      coupon_money: 0.0,
      item_subtotal: 0.0,
      money_free_shipping: 0.0,
      money_free_shipping_cost: 0.0,
      coupon_text: "没有可用优惠券",
      coupon_id: 0,
      exchange_code: null,
      address_id: -1,
      goods_id: 0,
      stock: 1,
      spec: "",
      payment_id: 1,
      user_note: "",
      site_model: "",
      user_info: false,

      //地址相关
      showCountryPicker: false,
      countryPicker: [{ id: 0, name: "请选择" }],
      showStatePicker: false,
      statePicker: [{ id: 0, name: "请选择" }],
      showCityPicker: false,
      cityPicker: [{ id: 0, name: "请选择" }],
      countryName: "请选择",
      stateName: "请选择",
      cityName: "请选择",
      country_id: 0,
      province_id: 0,
      city_id: 0,
      email: "",
      full_name: "",
      postal_code: "",
      tel: "",
      address_line: "",
      default_index: 0,
      pay_email_phone: false,
      address_just_email_phone: 0,
      isDefaultAddress: false,
    };
  },
  mounted(){
    let url = "api/agreement/maidian?type="+'orderSubmission'
    this.GET(url,function (ret) {
      if(ret.code === 0){
        console.log('请求成功')
      }
    })
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    onConfirm(coupons) {
      this.coupon_id = coupons.id;
      this.coupon_text = coupons.name;
      this.showPicker = false;
      if (this.coupon_id > 0) {
        this.getCoupon();
      } else {
        this.coupon_money = 0.0;
        this.CartBaseTotal();
      }
    },
    /**
     * 获取页面数据信息
     * @author  Devil
     * @version 1.0.0
     * @date    2020-03-21
     * @desc    description
     */
    getData() {
      var url = "api/buy/index";
      var data = {};
      if (this.buy_type == "goods") {
        data = JSON.parse(localStorage.getItem("buy_now_goods_info"));
      } else {
        data = { ids: this.ids, buy_type: this.buy_type };
      }
      var _self = this;

      this.POST(url, data, function (data) {
        if (data.code == 0) {
          _self.goods_list = data.data.goods_list;
          if (_self.goods_list.length == 1) {
            _self.spec = _self.goods_list[0]["spec"];
          }
          _self.address_list = data.data.user_address_list;
          _self.base = data.data.base;
          if (_self.base.address != null) {
            _self.email = _self.base.address.email;
            _self.tel = _self.base.address.tel;
          }
          _self.item_subtotal = data.data.base.total_price;
          //
          _self.money_free_shipping_cost = data.data.money_free_shipping_cost;
          _self.shipping_cost = data.data.money_free_shipping_cost;
          //over money
          _self.money_free_shipping = data.data.money_free_shipping;
          _self.payment_id = data.data.payment_list[0].id;
          _self.grand_total = data.data.grand_total;
          if (data.data.base.address !== null) {
            _self.address_id = data.data.base.address.id;
          }

          if (_self.grand_total >= _self.money_free_shipping) {
            _self.shipping_cost = 0.0;
          }

          if (data.data.country !== null) {
            _self.countryPicker = _self.countryPicker.concat(data.data.country);
          }
          if (data.data.province !== null) {
            _self.statePicker = _self.statePicker.concat(data.data.province);
          }
          if (data.data.city !== null) {
            _self.cityPicker = _self.cityPicker.concat(data.data.city);
          }

          if (data.data.coupon.length > 0) {
            var coupon_json = [{ id: 0, name: "没有可用优惠券" }];
            var coupon_arr = data.data.coupon;
            for (var i = 0; i < coupon_arr.length; i++) {
              var coupon_ob = {};
              coupon_ob.id = coupon_arr[i].id;
              coupon_ob.name = coupon_arr[i].name;
              coupon_json.push(coupon_ob);
            }
            _self.columns = coupon_json;
            if (data.data.coupon.length == 1) {
              _self.coupon_id = _self.columns[1].id;
              _self.coupon_text = _self.columns[1].name;
              _self.default_index = 1;
              _self.getCoupon();
            }
          }
        }
      });
    },
    /**
     * 获取优惠券金额
     * @author  Devil
     * @version 1.0.0
     * @date    2020-03-21
     * @desc    description
     */
    getCoupon() {
      var url = "api/coupon/couponamount";
      var data = { id: this.coupon_id, total_money: this.item_subtotal };
      var _self = this;

      this.POST(url, data, function (data) {
        if (data.code == 0) {
          _self.coupon_money = data.data.coupon_amount;
          _self.CartBaseTotal();
        }
      });
    },
    /**
     * 计算选择的商品总数和总价
     * @author  Devil
     * @version 1.0.0
     * @date    2020-03-21
     * @desc    description
     */
    CartBaseTotal() {
      if (this.item_subtotal - this.coupon_money < this.money_free_shipping) {
        this.shipping_cost = this.money_free_shipping_cost;
      }
      this.grand_total =
        this.item_subtotal - this.coupon_money + this.shipping_cost;
    },
    /**
     * 兑换优惠券
     */
    exchangeCode() {
      this.getUserInfo();
      if (this.exchange_code === "") {
        this.$toast("请输入优惠券兑换码");
        return false;
      }
      var url = "api/coupon/redeemcoupons";
      var data = { exchange_code: this.exchange_code };
      var _self = this;

      this.POST(url, data, function (data) {
        if (data.code === 0) {
          _self.$toast(data.msg);
          setTimeout(function () {
            window.location.reload();
          }, 500);
        } else {
          _self.$toast(data.msg);
        }
      });
    },
    changeCity(e, type) {
      var _self = this;
      var url = "";
      var data = "";
      if (type === "country") {
        if (e.id > 0) {
          this.countryName = e.name;
          this.country_id = e.id;
          this.showCountryPicker = false;
          url = "api/region/index";
          data = { pid: e.id };
          this.POST(url, data, function (ret) {
            if (ret.code === 0) {
              _self.province_id = 0;
              _self.stateName = "请选择";
              _self.statePicker = [{ id: 0, name: "请选择" }];
              _self.statePicker = _self.statePicker.concat(ret.data);

              _self.city_id = 0;
              _self.cityName = "请选择";
              _self.cityPicker = [{ id: 0, name: "请选择" }];
              _self.cityPicker = _self.cityPicker.concat(ret.data);
            }
          });
        } else {
          this.showStatePicker = false;
          this.showStatePicker = false;
          _self.province_id = 0;
          _self.stateName = "请选择";
          _self.statePicker = [{ id: 0, name: "请选择" }];
          _self.city_id = 0;
          _self.cityName = "请选择";
          _self.cityPicker = [{ id: 0, name: "请选择" }];
        }
      } else if (type === "state") {
        if (e.id > 0) {
          this.stateName = e.name;
          this.province_id = e.id;
          this.showStatePicker = false;
          url = "api/region/index";
          data = { pid: e.id };
          this.POST(url, data, function (ret) {
            if (ret.code === 0) {
              _self.city_id = 0;
              _self.cityName = "请选择";
              _self.cityPicker = [{ id: 0, name: "请选择" }];
              _self.cityPicker = _self.cityPicker.concat(ret.data);
            }
          });
        } else {
          this.showStatePicker = false;
          _self.city_id = 0;
          _self.cityName = "请选择";
          _self.cityPicker = [{ id: 0, name: "请选择" }];
        }
      } else if (type === "city") {
        this.cityName = e.name;
        this.city_id = e.id;
        this.showCityPicker = false;
      }
    },
    saveAddress() {
      var _self = this;
      if (this.country_id == 0) {
        this.$toast("请选择省份");
        return false;
      }
      if (this.province_id == 0) {
        this.$toast("请选择城市");
        return false;
      }
      if (this.city_id == 0) {
        this.$toast("请选择区县");
        return false;
      }
      var url = "api/useraddress/save";
      var data = {
        name: this.full_name,
        city: this.city_id,
        email: this.email,
        country: this.country_id,
        province: this.province_id,
        postal_code: this.postal_code,
        tel: this.tel,
        address: this.address_line,
      };
      this.POST(url, data, function (ret) {
        if (ret.code === 0) {
          // window.location.reload();
          _self.$toast('地址保存成功');
        } else {
          _self.$toast(ret.msg);
        }
      });
    },
    pay: async function () {
      // var _self = this;
      // if (this.address_id === -1) {
      //     if (this.full_name == "") {
      //         this.$toast("Please input full name");
      //         return false;
      //     }
      //     if (this.email == "") {
      //         this.$toast("Please input email");
      //         return false;
      //     }
      //     var reg = /^\w[-\w.+]*@([A-Za-z0-9][-A-Za-z0-9]+\.)+[A-Za-z]{2,14}/;
      //     if (!reg.test(this.email)) {
      //         this.$toast("Email format error");
      //         return false;
      //     }
      //     if (this.address_line == "") {
      //         this.$toast("Please input address line");
      //         return false;
      //     }
      //     if (this.postal_code == "") {
      //         this.$toast("Please input postal code");
      //         return false;
      //     }
      //     if(this.country_id == 0){
      //         this.$toast('Please select a country');
      //         return false;
      //     }
      //     if (this.province_id == 0) {
      //         this.$toast("Please select a state");
      //         return false;
      //     }
      //     if (this.city_id == 0) {
      //         this.$toast("Please select a city");
      //         return false;
      //     }
      //     // if (this.tel == "") {
      //     //     this.$toast("Please input tel");
      //     //     return false;
      //     // }
      //     var url_address = "api/useraddress/save";
      //     var data_address = {
      //         name: this.full_name,
      //         city: this.city_id,
      //         email: this.email,
      //         country:this.country_id,
      //         province: this.province_id,
      //         postal_code: this.postal_code,
      //         tel: this.tel,
      //         address: this.address_line,
      //     };

      //     this.POST(url_address, data_address, function (ret) {
      //         window.console.log(1);
      //         if (ret.code === 0) {
      //             _self.address_id = ret.data.id;
      //             window.console.log(_self.address_id);
      //             _self.go_add();
      //         } else {
      //             _self.$toast(ret.msg);
      //             return false;
      //         }
      //     });
      //     // this.$toast("Please fill in the address");
      //     // return false;
      // } else {
      //     this.go_add();
      // }
      this.go_add();
    },
    go_add() {
      var url = "/api/buy/add";
      var data = {};
      var _self = this;
      if (this.buy_type == "goods") {
        data = {
          goods_id: this.ids,
          buy_type: this.buy_type,
          stock: this.stock,
          spec: this.spec,
          ids: this.ids,
          address_id: this.address_id,
          payment_id: this.payment_id,
          user_note: this.user_note,
          coupon_id: this.coupon_id,
          site_model: 0,
          tel: this.tel,
          email: this.email,
          address_just_email_phone: this.address_just_email_phone,
        };
      } else {
        data = {
          goods_id: 0,
          buy_type: this.buy_type,
          stock: this.stock,
          spec: this.spec,
          ids: this.ids,
          address_id: this.address_id,
          payment_id: this.payment_id,
          user_note: this.user_note,
          coupon_id: this.coupon_id,
          site_model: 0,
          tel: this.tel,
          email: this.email,
          address_just_email_phone: this.address_just_email_phone,
        };
      }
      if (this.radio1 == 2) {
        data.pay_upon_invoice = 1;
      } else {
        // if (this.email == "") {
        //   this.$toast("请填写电子邮件");
        //   return false;
        // }
        if (this.tel == "") {
          this.$toast("请填写手机号码");
          return false;
        }
      }
      this.POST(url, data, function (ret) {
        window.console.log(2);
        if (ret.code === 0) {
          // _self.$toast.success(ret.msg);
          window.fbq("trackCustom", "do_pay_now_h5", { id: data.goods_id });
          window.gtag("event", "do_pay_now_h5", {
            method: "do_pay_now_h5",
            content: data.goods_id,
            value: data.goods_id,
            value_goods_id: data.goods_id,
          });
          setTimeout(function () {
            _self.to_pay(ret.data.order.id);
            _self.$toast.loading({
              message: "等待中...",
              forbidClick: true,
            });
          }, 1500);
        } else {
          _self.$toast.fail(ret.msg);
        }
      });
    },
    to_pay(order_id) {
      var _this = this;
      this.POST("api/order/pay", { id: order_id }, function (ret) {
        _this.$toast.loading({
          message: "加载中...",
          forbidClick: true,
        });
        // if (ret.code === 0) {
        //   window.location.href = ret.data.data;
        // }
        if (ret.code === -1) {
          // _this.$toast.fail(ret.msg);
          _this.$toast.loading({
            message: ret.msg,
            forbidClick: true,
          });
          setTimeout(()=>{
            _this.$router.push({
              path:'/Orders',
              query:{
                name: 'Unpaid'
              }
            })
          },2000)
        }
      });
    },
    chooespay() {
      if (this.radio1 == 1) {
        this.pay_email_phone = true;
        this.address_just_email_phone = 1;
      } else {
        this.pay_email_phone = false;
        this.address_just_email_phone = 0;
      }
    },
  },
};
</script>